import * as React from 'react';

const SvgRotateLeft = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
    <svg viewBox="0 0 22.18 19.08">
        <path d="M3.15,8.64l-2.25-3a0.5,0.5,0,1,0-.8.6l3.14,4.19a0.5,0.5,0,0,0,.34.2A0.51,0.51,0,0,0,4,10.51L8,7.14a0.51,0.51,0,0,0,.18-0.38A0.49,0.49,0,0,0,8,6.43a0.5,0.5,0,0,0-.7-0.06l-3.2,2.7a8.54,8.54,0,1,1,3.37,7.28,0.5,0.5,0,0,0-.6.8,9.54,9.54,0,0,0,15.3-7.6c0-.15,0-0.3,0-0.45A9.53,9.53,0,0,0,3.15,8.64Z" transform="translate(0 0)" style="fill:#cdcccc"/
    ></svg>
);

export default SvgRotateLeft;
